import { WallboxHistoryChartData, WallboxHistoryModel } from '../models/history-data'
import { roundPositiveAndScale } from '../utils'

type Factor = 1 | 4

/**
 * Transform one or many wallbox's data (fetched from database) to rechart data so they can be displayed in a system chart.
 *
 * @param dto
 * @param factor - 'day' view data needs to be scaled by 4
 * @param timestampHourShift this is a temporary fix for the month view. The data is shifted by one day.
 * @param wallboxDataMap Different wallboxes can have data for the same timestamp. Map maps timestamps with data.
 * @returns
 */
export const fromWallboxHistoryToRechartData = (
  dto: WallboxHistoryModel[],
  factor: Factor,
  wallboxDataMap: Map<number, WallboxHistoryChartData>, // Pass the existing map for merging
  wallboxNumber: number
): Map<number, WallboxHistoryChartData> => {
  dto?.forEach(dataPoint => {
    const existingTimeStamp = wallboxDataMap.has(dataPoint.time)

    const totalWallboxData = {
      Wallbox_energyAll: roundPositiveAndScale(dataPoint.energyAll, factor),
      Wallbox_energyDischarged: roundPositiveAndScale(dataPoint.energyDischarged, factor),
      Wallbox_energySolar: roundPositiveAndScale(dataPoint.energySolar, factor),
    }

    const specificWallboxData = {
      [`wb${wallboxNumber}/Wallbox_energyAll`]: roundPositiveAndScale(dataPoint.energyAll, factor),
      [`wb${wallboxNumber}/Wallbox_energyDischarged`]: roundPositiveAndScale(dataPoint.energyDischarged, factor),
      [`wb${wallboxNumber}/Wallbox_energySolar`]: roundPositiveAndScale(dataPoint.energySolar, factor),
    }

    if (existingTimeStamp) {
      const existingEntry = wallboxDataMap.get(dataPoint.time)!
      existingEntry.Wallbox_energyAll += totalWallboxData.Wallbox_energyAll
      existingEntry.Wallbox_energyDischarged += totalWallboxData.Wallbox_energyDischarged
      existingEntry.Wallbox_energySolar += totalWallboxData.Wallbox_energySolar

      existingEntry[`wb${wallboxNumber}/Wallbox_energyAll`] = roundPositiveAndScale(dataPoint.energyAll, factor)
      existingEntry[`wb${wallboxNumber}/Wallbox_energyDischarged`] = roundPositiveAndScale(dataPoint.energyDischarged, factor)
      existingEntry[`wb${wallboxNumber}/Wallbox_energySolar`] = roundPositiveAndScale(dataPoint.energySolar, factor)
    } else {
      wallboxDataMap.set(dataPoint.time, {
        ...totalWallboxData,
        ...specificWallboxData,
        ts: dataPoint.time,
        time: dataPoint.time,
        from: dataPoint.from,
      })
    }
  })

  return wallboxDataMap
}
